import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

export default function AdminPage() {
  const [state, setState] = useState<"checking" | "authed" | "anon">("checking");

  useEffect(() => {
    const token = localStorage.getItem("fosche_admin_token");
    if (!token) {
      setState("anon");
      return;
    }
    api
      .get("/auth/me")
      .then(() => setState("authed"))
      .catch(() => {
        localStorage.removeItem("fosche_admin_token");
        setState("anon");
      });
  }, []);

  if (state === "checking")
    return (
      <div className="min-h-screen bg-canvas flex items-center justify-center">
        <p className="font-mono-tech text-xs tracking-[0.3em] uppercase text-sub animate-pulse">Authenticating…</p>
      </div>
    );

  return state === "authed" ? (
    <AdminDashboard onLogout={() => setState("anon")} />
  ) : (
    <AdminLogin onSuccess={() => setState("authed")} />
  );
}
